import { map, pick } from 'ramda';
import currencyCodes from 'currency-codes/data';

const ISOCurrencyList = map(pick(['code', 'number']), currencyCodes);

export { ISOCurrencyList };
